import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Progress, Alert } from "antd";
import { ReactComponent as HelpIcon } from "../../../assets/UiElements/help.svg";

export const NeedHelpPage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  // Simulate a loading progress (this can be a countdown or any data fetching logic)
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(interval);
        }
        return Math.min(oldProgress + 10, 100);
      });
    }, 1000); // Increase progress by 10 every second for demo purposes
    return () => clearInterval(interval);
  }, []);

  const handleContactSupport = () => {
    navigate("/contact-support");
  };

  const handleFAQ = () => {
    navigate("/faq");
  };

  return (
    <div className="need-help-container" style={styles.container}>
      <div className="need-help-header" style={styles.header}>
        <HelpIcon style={styles.icon} />
        <h2 style={styles.title}>UI Design is Not Ready</h2>
        <p style={styles.description}>We’re working hard to get everything ready. Please come back later.</p>
      </div>

      <div className="need-help-progress" style={styles.progressContainer}>
        <Progress percent={progress} status="active" strokeColor="#4CAF50" />
        <div style={styles.progressText}>{`Progress: ${progress}%`}</div>
      </div>

      <Alert
        message="Please note"
        description="The UI is under construction. Some features may not be available right now."
        type="warning"
        showIcon
        style={styles.alert}
      />

      <div className="need-help-options" style={styles.buttonContainer}>
        <Button
          type="primary"
          onClick={handleContactSupport}
          style={styles.button}
        >
          Contact Support
        </Button>

        <Button
          type="default"
          onClick={handleFAQ}
          style={styles.button}
        >
          Frequently Asked Questions (FAQ)
        </Button>
      </div>

      <div className="need-help-footer" style={styles.footer}>
        <p style={styles.footerText}>© {new Date().getFullYear()} Your Company - All Rights Reserved</p>
      </div>
    </div>
  );
};

// Inline styles for a modern and clean look
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
  },
  header: {
    textAlign: "center",
    marginBottom: "30px",
  },
  icon: {
    width: "60px",
    height: "60px",
    marginBottom: "20px",
    fill: "#4CAF50",
  },
  title: {
    fontSize: "32px",
    color: "#333",
    fontWeight: "bold",
  },
  description: {
    color: "#777",
    fontSize: "16px",
    marginBottom: "20px",
  },
  progressContainer: {
    width: "80%",
    maxWidth: "600px",
    marginBottom: "30px",
  },
  progressText: {
    textAlign: "center",
    fontSize: "14px",
    color: "#555",
    marginTop: "10px",
  },
  alert: {
    width: "80%",
    maxWidth: "600px",
    marginBottom: "30px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "80%",
    maxWidth: "400px",
  },
  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
  },
  footer: {
    position: "absolute",
    bottom: "20px",
    width: "100%",
    textAlign: "center",
  },
  footerText: {
    fontSize: "12px",
    color: "#aaa",
  },
};

export default NeedHelpPage;
